// extracted by mini-css-extract-plugin
module.exports = {"root":"featured-work-module--root--12iTI","title":"featured-work-module--title--2jy3v","buttonWrapper":"featured-work-module--buttonWrapper--3ypt9"};